import {FAILD_MESSAGE_ADD_EMPLYEE } from "../actions/type";

const initialState ={
    registred_member:'',
    registered_emp_id:'',
    registered_mail:'',
    submit_sucsess:''
}

const addEmployeeReducer = (state = initialState , action) => {
    const newState = {...state}
    switch (action.type) {
            case FAILD_MESSAGE_ADD_EMPLYEE:
            return {
                ...state,
                registred_member: [action.registred_member],
                registered_mail: [action.registered_mail],
                registered_emp_id: [action.registered_emp_id],
                submit_sucsess:1
            }
            break;
        default:
            break;
            
    }
    return newState
}

export { addEmployeeReducer };


// WEBPACK FOOTER //
// ./src/reducers/addEmployeeReducer.js